module.exports = __webpack_public_path__ + "static/media/yellow.e41c977d.jpeg";